import { useEffect, useState } from "react";
import { FormifyInputStyle } from "../../../../assets/styles";
import Moment from "../../../../modules/Moment/Moment";
import req from "../../../../modules/Request";
import { clsx } from "../../../../modules/Utilkit/Utilkit";
import { useNotify } from "../../../components/Notify";


const TaskFormEdit = ({ task, setTasks, holidays, onClose, workingHours, tasks }) => {
	const { notify } = useNotify();

	const [ resources, setResources ] = useState(+task.resources);
	const [ start, setStart ] = useState(task.start);
	const [ duration, setDuration ] = useState(+task.duration);
	const [ end, setEnd ] = useState(task.end);
	const [ label, setLabel ] = useState(task.name === task.origin ? '' : task.name);
	const [ sequence, setSequence ] = useState(task.sequence ?? Number(task.position.split('.').pop()));

	const [ reqData, setReqData ] = useState(task);
	const [ loading, setLoading ] = useState(false);

	useEffect(() => {
		setResources(+task.resources);
		setStart(task.start);
		setDuration(+task.duration);
		setEnd(task.end);
		setSequence(task.sequence ?? Number(task.position.split('.').pop()));
		setLabel(task.name === task.origin ? '' : task.name);
	}, [ task ]);

	useEffect(() => {
		const data = { ...task };

		data.start = start;
		data.label = label;
		data.duration = duration;
		data.end = end;
		data.resources = resources;
		data.position = task.position;

		if (task.record === 'ST') {
			data.sequence = sequence;
		}

		setReqData(data);
	}, [ resources, start, duration, end, label, sequence ]);

	const handleSubmit = (e) => {
		e.preventDefault();

		if (holidays.includes(start)) {
			notify('Data Inizio', "La data non può essere un giorno festivo.", 'error');
			return;
		} else if (holidays.includes(end)) {
			notify('Data Fine', "La data non può essere un giorno festivo.", 'error');
			return;
		}

		const fatherPosition = task.position.split('.').slice(0, -1).join('.');

		const taskWithSamePosition = task.record === 'ST'
			? tasks.find(t => t.position === fatherPosition + '.' + reqData.sequence && +t.id !== +task.id) :
			null;

		setLoading(true);

		req('sync-task', {
			task: reqData,
			taskWithSamePositionId: taskWithSamePosition?.id ?? null
		}).then(async (res) => {
			if (res.success) {
				const originalSequence = task.sequence ?? Number(task.position.split('.').pop());
				setTasks(tasks => tasks.map(t => {
					if (+t.id === +task.id) {
						return {
							...reqData,
							moved: 1,
							name: reqData.label || task.origin,
							position: task.record === 'ST'
								? fatherPosition + '.' + reqData.sequence
								: task.position,
							sequence: reqData.sequence
						};
					} else if (+t.id === +taskWithSamePosition?.id) {
						return {
							...t,
							position: fatherPosition + '.' + originalSequence,
							sequence: originalSequence
						};

					} else {
						return t;
					}
				}));
				onClose();
			} else {
				notify(res.error, "Errore durante l'aggiornamento del task.", 'error');
				setLoading(false);
			}
		}).catch(() => {
			setLoading(false);
		});

	};

	return (
		<form className="min-w-[220px] flex flex-col items-center text-center" onSubmit={ handleSubmit }>
			<div className="w-full font-semibold border-b border-gray-400">Modifica Task</div>

			<div className="flex flex-col justify-center items-center space-y-1 pb-2">
				<div className="flex flex-col w-full">
					<label>Titolo</label>

					<input
						className={ FormifyInputStyle }
						value={ label }
						maxLength={ 50 }
						onInput={ (e) => task.record === 'ST' && setLabel(e.target.value) }
						placeholder={ task.origin }
						disabled={ task.record !== "ST" }
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Data Inizio</label>

					<input
						className={ FormifyInputStyle }
						required={ true }
						type="date"
						value={ start }
						onInvalid={ (e) => {
							e.preventDefault();
							notify('Data Inizio', e.target.validationMessage, 'error');
						} }
						onInput={ (e) => {
							if (!holidays.includes(e.target.value)) {
								setStart(e.target.value);

								if (!isNaN(Date.parse(e.target.value)) && new Date(e.target.value) > new Date('2000-01-01')) {
									setEnd(new Moment(e.target.value).end(duration / workingHours, holidays));
								}
							} else {
								notify('Data Inizio', "La data non può essere un giorno festivo.", 'error');
							}
						} }
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Data Fine</label>

					<input
						className={ FormifyInputStyle }
						required={ true }
						type="date"
						min={ start }
						value={ end }
						onInvalid={ (e) => {
							e.preventDefault();
							notify('Data Fine', e.target.validationMessage, 'error');
						} }
						onInput={ (e) => {
							if (!holidays.includes(e.target.value)) {
								setEnd(e.target.value);
								setDuration((new Moment(start).duration(e.target.value, { blacklist: holidays }) + 1) * workingHours);
							} else {
								notify('Data Fine', "La data non può essere un giorno festivo.", 'error');
							}
						} }
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Durata Per Persona (Ore)</label>

					<input
						className={ FormifyInputStyle }
						required={ true }
						type="number"
						min={ 0 }
						value={ duration }
						onInput={ (e) => {
							const val = Number(e.target.value);
							if (val < 1) {
								notify('Durata', 'Deve essere almeno 1 ora', 'error');
								return;
							}

							setDuration(val);
							setEnd(new Moment(start).end(val / workingHours, holidays));
						} }
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Numero Persone</label>

					<input
						className={ FormifyInputStyle }
						required={ true }
						min={ 1 }
						step={ 1 }
						type="number"
						onInvalid={ (e) => {
							e.preventDefault();
							notify('Errore', e.target.validationMessage, 'error');
						} }
						value={ resources }
						onInput={ (e) => {
							const val = Number(e.target.value);

							if (val < 1) {
								notify('Numero Persone', 'Deve essere ≥ 1', 'error');
								return;
							}

							setDuration(prevDur => {
								const newDur = prevDur * resources / val;
								setEnd(new Moment(start).end(newDur / workingHours, holidays));
								return newDur;
							});
							setResources(val);
						} }
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Durata Totale (Ore)</label>

					<input className={ FormifyInputStyle } disabled={ true } value={ resources * duration } />
				</div>

				{ task.record === 'ST' && (
					<div className="flex flex-col w-full">
						<label>Sequenza</label>

						<input
							className={ FormifyInputStyle }
							required={ true }
							min={ 1 }
							step={ 1 }
							type="number"
							onInvalid={ (e) => {
								e.preventDefault();
								notify('Errore', e.target.validationMessage, 'error');
							} }
							value={ sequence }
							onInput={ (e) => {
								setSequence(Number(e.target.value));
							} }
						/>
					</div>
				) }

				<button
					disabled={ loading }
					className={ clsx(
						"border disabled:bg-green-300 disabled:border-green-200 rounded-sm",
						"px-4 py-0.5 duration-75 bg-green-500 hover:bg-green-400",
						"border-green-400 hover:border-green-300 text-white",
						"flex items-center justify-center space-x-1.5"
					) }
				>
					{ loading ? (
						<>
							<span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
							<span>Salvataggio...</span>
						</>
					) : 'Salva' }
				</button>
			</div>
		</form>
	);
};

export default TaskFormEdit;